import React, { useEffect } from 'react';
import "./TermsOfService.css";

const TermsOfService = () => {
  useEffect(() => {
    document.body.classList.add("terms-page");
    return () => { document.body.classList.remove("terms-page"); };
  }, []);

  return (
    <div className="tos-wrapper">
      <div className="tos-container">
        <h1>شرایط و قوانین استفاده</h1>

        <section>
          <h2>درباره راهنمای دوپینگ</h2>
          <p>راهنمای دوپینگ یک دستیار هوشمند مبتنی بر هوش مصنوعی است که اطلاعات دقیق درباره مواد ممنوعه، قوانین WADA و مقررات ضد دوپینگ را در اختیار ورزشکاران، مربیان و متخصصان ورزشی قرار می‌دهد.</p>
          <p>هدف‌های ما:</p>
          <ul>
            <li>کمک به ورزشکاران برای آگاهی از مواد ممنوعه</li>
            <li>ارائه اطلاعات دقیق بر اساس فهرست ممنوعه WADA 2025</li>
            <li>کاهش تخلفات ناخواسته دوپینگ از طریق آموزش</li>
            <li>راهنمایی درباره TUE (معافیت استفاده درمانی)</li>
            <li>پاسخ به سوالات مربیان و پزشکان ورزشی</li>
          </ul>
        </section>

        <section>
          <h2>محدودیت‌های مهم</h2>
          <p>این دستیار صرفاً جنبه اطلاع‌رسانی دارد و <strong>جایگزین مشاوره پزشکی یا حقوقی نیست.</strong></p>
          <ul>
            <li>برای تصمیم‌های پزشکی حتماً با پزشک مشورت کنید.</li>
            <li>در موارد رسمی، با فدراسیون ورزشی مربوطه تماس بگیرید.</li>
            <li>هوش مصنوعی ممکن است خطا داشته باشد — همیشه منابع رسمی WADA را بررسی کنید.</li>
            <li>قوانین ممکن است تغییر کنند؛ آخرین نسخه فهرست ممنوعه را از سایت WADA دریافت کنید.</li>
          </ul>
        </section>

        <section>
          <h2>استفاده از داده‌ها</h2>
          <p>اطلاعات مکالمات شما برای بهبود کیفیت دستیار استفاده می‌شود. تمام داده‌ها محرمانه نگهداری شده و به اشخاص ثالث منتقل نمی‌شود.</p>
        </section>

        <section>
          <h2>مسئولیت‌ها</h2>
          <p>این سامانه تلاش می‌کند دقیق‌ترین اطلاعات را ارائه دهد، اما مسئولیت تصمیمات نهایی با کاربر است.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
